const API_URL = process.env.REACT_APP_SERVER_URL;

const UseSignup = async (user) =>{
  
    const response = await fetch(`${API_URL}/signup`,{
        method:"POST",
        headers:{
            'Content-Type':"application/json",
        },
        body:JSON.stringify(user)
    });
    const result = await response.json();
    return result;

}

export default UseSignup;